import * as React from 'react';

function SvgFileEarmarkExcelFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M9.293 0H4a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4.707A1 1 0 0013.707 4L10 .293A1 1 0 009.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 01-1-1zM5.884 6.68L8 9.219l2.116-2.54a.5.5 0 11.768.641L8.651 10l2.233 2.68a.5.5 0 01-.768.64L8 10.781l-2.116 2.54a.5.5 0 01-.768-.641L7.349 10 5.116 7.32a.5.5 0 11.768-.64z' />
		</svg>
	);
}

export default SvgFileEarmarkExcelFill;
